module.exports = __webpack_public_path__ + "static/img/3_7_2.03d8e3d6.jpg";